import type { OrganizationSelection } from '../types/organization-selection';

class OrganizationSelections {
  public static From(value: unknown): OrganizationSelection | undefined {
    let selection: OrganizationSelection | undefined;
    if (value && typeof value === 'object') {
      const candidate = value as { name?: unknown; precedence?: unknown };
      if (typeof candidate.name === 'string' &&
        candidate.name.length > 0 &&
        typeof candidate.precedence === 'number' &&
        Number.isFinite(candidate.precedence)) {
        selection = { name: candidate.name, precedence: candidate.precedence };
      }
    }
    return selection;
  }

  public static Key(value: OrganizationSelection | null | undefined): string {
    let key = '';
    const selection = OrganizationSelections.From(value);
    if (selection) {
      key = `${selection.precedence}:${selection.name}`;
    }
    return key;
  }

  public static IsSame(left: OrganizationSelection | null | undefined, right: OrganizationSelection | null | undefined): boolean {
    const leftKey = OrganizationSelections.Key(left);
    return leftKey.length > 0 && leftKey === OrganizationSelections.Key(right);
  }

  public static GetLink(accountBase: string, selection: OrganizationSelection, continueUrl: string): string {
    const base = accountBase.replace(/\/$/, '');
    return `${base}/auth/organization?name=${encodeURIComponent(selection.name)}&precedence=${selection.precedence}&continue=${encodeURIComponent(continueUrl)}`;
  }
}

export { OrganizationSelections };
